import { useExperiencesContext } from '../../experiences/Experiences';
import { useRouterContext } from '../../../context/PlpContext';

export const useHorizontalFilterNavDropdownData = () => {
  const experiences = useExperiencesContext();
  const router = useRouterContext();
  const { isHorizontalFilterNavDropdownFlagOn } = experiences;
  return {
    router,
    isHorizontalFilterNavDropdownFlagOn,
  };
};
